import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/common-models';
import { DynamicFormService } from '../../service/dynamic-form.service';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-form-input-select',
    templateUrl: './form-input-select.component.html',
    styleUrls: ['./form-input-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormInputSelectComponent implements OnInit {
  config: FieldConfig;
  group: UntypedFormGroup;
  FormControlName: any;
  constructor(public dfs: DynamicFormService, public gs: GuestService) { }

  ngOnInit(): void {
    this.FormControlName = this.config.name;
    //console.log(this.group)
  }

  selectedOption(event){
    if (this.config.cellClick){
      this.config.cellClick(event);
    }
  }

  onKeyup(event) {
    if (this.config.blurClick) {
      this.config.blurClick(event);
    }
  }

}
